module.exports = __webpack_public_path__ + "img/home-07-cosmo-popup-bg-02.8cf3d58f.jpg";